import { Currency } from '../asset-holders/Currency'
import { proximaApi } from '../proximaApi'
import {
  type CurrencyExchangeInstructionDetails
} from '../schema-dtos/CurrencyExchangeInstructionDomainDtos'

const SUB_URL = '/currency-exchanges/asset-holders'

export const currencyExchangeInstructionApi = proximaApi.injectEndpoints({
  endpoints: (builder) => ({
    getPendingInstructions: builder.query<CurrencyExchangeInstructionDetails[], Partial<number>>({
      query: (assetHolderId: number) => ({
        url: `${SUB_URL}/${assetHolderId}/instructions`,
        method: 'GET'
      }),
      providesTags: ['AssetHolderFinancials'],
      transformResponse: (response: CurrencyExchangeInstructionDetails[], meta, arg: number) => response
    }),

    // Payload: back-end-v2/src/domains/financial/api-schema-dtos/CurrencyExchangeAssetHolderPayloadDtos.ts
    createInstruction: builder.mutation({
      query: (payload: any) => ({
        url: `${SUB_URL}/${payload.assetHolderId}/instructions/create`,
        method: 'POST',
        body: {
          assetHolderId: payload.assetHolderId,
          fromCurrencyCode: Currency.ZAR,
          toCurrencyCode: Currency.XBT,
          otp: payload.otp
        }
      }),
      invalidatesTags: ['AssetHolderFinancials', 'AssetHolderSettlement']
    }),

    cancelInstruction: builder.mutation({
      query: (payload: any) => ({
        url: `${SUB_URL}/${payload.assetHolderId}/instructions/cancel`,
        method: 'POST',
        body: {
          assetHolderId: payload.assetHolderId,
          instructionId: payload.instructionId,
          otp: payload.otp
        }
      }),
      invalidatesTags: ['AssetHolderFinancials', 'AssetHolderSettlement']
    })

  }),

  overrideExisting: false

})

export const useGetPendingCurrencyExchangeInstructionsQuery = currencyExchangeInstructionApi.endpoints.getPendingInstructions.useQuery
export const useCreateCurrencyExchangeInstructionMutation = currencyExchangeInstructionApi.endpoints.createInstruction.useMutation
export const useCancelCurrencyExchangeInstructionMutation = currencyExchangeInstructionApi.endpoints.cancelInstruction.useMutation
